<template>
  <a-drawer :title="title" width="60%" :visible="visible" :body-style="{ paddingBottom: '80px' }" @close="hide">
    <a-spin :spinning="loading">
      <div class="drawer-content">
        <a-descriptions title="基本信息" :column="2" bordered>
          <a-descriptions-item label="评论编号">{{ detailData.id || '-' }}</a-descriptions-item>
          <a-descriptions-item label="文章名称">{{ detailData.articleName || '-' }}</a-descriptions-item>
          <a-descriptions-item label="评论人名称">{{ detailData.userName || '-' }}</a-descriptions-item>
          <a-descriptions-item label="评论人手机号">{{ detailData.userMobile || '-' }}</a-descriptions-item>
          <a-descriptions-item label="点赞数量">
            <span class="stat-text">{{ detailData.up || 0 }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="评论时间">{{ formatTime(detailData.commentTime) || '-' }}</a-descriptions-item>
          <a-descriptions-item label="创建时间">{{ formatTime(detailData.createTime) || '-' }}</a-descriptions-item>
          <a-descriptions-item label="评论类型">
            <a-tag :color="detailData.articleCommentPid === -1 ? 'blue' : 'green'">
              {{ detailData.articleCommentPid === -1 ? '评论文章' : '回复评论' }}
            </a-tag>
          </a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="评论内容" :column="1" bordered style="margin-top: 16px">
          <a-descriptions-item>
            <div class="content-wrapper">{{ detailData.text || '--' }}</div>
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </a-spin>

    <div class="drawer-footer">
      <a-button @click="hide">关闭</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { getComment } from '@/api/tutorial/comment'
import { message } from 'ant-design-vue'

export default {
  name: 'DetailDrawer',
  data() {
    return {
      visible: false,
      loading: false,
      detailData: {}
    }
  },
  computed: {
    title() {
      return '评论详情'
    }
  },
  methods: {
    show(record) {
      this.visible = true
      this.loadDetail(record.id)
    },
    hide() {
      this.visible = false
      this.detailData = {}
    },
    async loadDetail(id) {
      this.loading = true
      try {
        const response = await getComment(id)
        if (response && (response.code === '20001' || response.success)) {
          this.detailData = response.data || {}
        } else {
          message.error(response.message || '获取详情失败')
        }
      } catch (error) {
        console.error('获取详情失败:', error)
        message.error('获取详情失败')
      } finally {
        this.loading = false
      }
    },
    formatTime(time) {
      if (!time) return '-'
      return new Date(time).toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    }
  }
}
</script>

<style scoped>
.drawer-content {
  padding: 0
}

.drawer-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

.stat-text {
  font-weight: 600;
  color: #1890ff
}

.content-wrapper {
  max-height: 400px;
  overflow-y: auto;
  word-wrap: break-word;
}

.ant-descriptions {
  margin-bottom: 0;
}
</style>

